import {
  createSuccessType,
  createSubmitType,
  createErrorType,
  createFetchType,
  createLoadingType,
} from '../actionHelpers';

export const CREATE_AGREEMENT_SCOPE = 'CREATE_AGREEMENT';
export const CREATE_AGREEMENT = createSubmitType(CREATE_AGREEMENT_SCOPE);
export const CREATE_AGREEMENT_SUCCESS = createSuccessType(
  CREATE_AGREEMENT_SCOPE,
);
export const CREATE_AGREEMENT_ERROR = createErrorType(CREATE_AGREEMENT_SCOPE);
export const CREATE_AGREEMENT_LOADING = createLoadingType(
  CREATE_AGREEMENT_SCOPE,
);

export const DOWNLOAD_AGREEMENT_SCOPE = 'DOWNLOAD_AGREEMENT';
export const DOWNLOAD_AGREEMENT = createFetchType(DOWNLOAD_AGREEMENT_SCOPE);
export const DOWNLOAD_AGREEMENT_SUCCESS = createSuccessType(
  DOWNLOAD_AGREEMENT_SCOPE,
);
export const DOWNLOAD_AGREEMENT_ERROR = createErrorType(
  DOWNLOAD_AGREEMENT_SCOPE,
);
export const DOWNLOAD_AGREEMENT_LOADING = createLoadingType(
  DOWNLOAD_AGREEMENT_SCOPE,
);

export const DOWNLOAD_PDF_AGREEMENT_SCOPE = 'DOWNLOAD_PDF_AGREEMENT';
export const DOWNLOAD_PDF_AGREEMENT = createFetchType(
  DOWNLOAD_PDF_AGREEMENT_SCOPE,
);
export const DOWNLOAD_PDF_AGREEMENT_SUCCESS = createSuccessType(
  DOWNLOAD_PDF_AGREEMENT_SCOPE,
);
export const DOWNLOAD_PDF_AGREEMENT_ERROR = createErrorType(
  DOWNLOAD_PDF_AGREEMENT_SCOPE,
);
export const DOWNLOAD_PDF_AGREEMENT_LOADING = createLoadingType(
  DOWNLOAD_PDF_AGREEMENT_SCOPE,
);
